import styled from '@emotion/styled';
import React from 'react';
import { TransitionGroup } from 'react-transition-group';

import { CollapseTransition } from '@/features/common';

import { useAutomationsTrigger } from '../automations-trigger-provider';

import { TriggerNotification } from './trigger-notification';

export function TriggerNotifications() {
  const { automationTriggers, removeAutomationTrigger, runAutomationTrigger } =
    useAutomationsTrigger();

  return (
    <TriggerNotificationsWrapper>
      <TriggerNotificationsTransitionGroup>
        {Array.from(automationTriggers.entries()).map(([id, trigger]) => (
          <CollapseTransition key={`automation-trigger-${id}`}>
            <TriggerNotificationItem>
              <TriggerNotification
                content={trigger}
                onRun={() => runAutomationTrigger(id)}
                onCancel={() => removeAutomationTrigger(id)}
              />
            </TriggerNotificationItem>
          </CollapseTransition>
        ))}
      </TriggerNotificationsTransitionGroup>
    </TriggerNotificationsWrapper>
  );
}

const TriggerNotificationsWrapper = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;
  width: 100%;
  width: -webkit-fill-available; /* Chrome, Safari, Edge (Chromium-based) */
  width: -moz-available; /* Firefox */
`;

const TriggerNotificationsTransitionGroup = styled(TransitionGroup)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TriggerNotificationItem = styled.div`
  padding-bottom: 24px;
  pointer-events: all;
`;
